import Vue from 'vue';
import axios from 'axios'; 
import '../../filters';
import moment from 'moment';
import users from '../../users';
import * as files from '../../fileUtils';

const uiDateFormat = 'DD/MM/YYYY';

export default {
  name: 'Dashscreen',
  mixins: [users],
  components: {
    dashboardComp: require('./../dashboards.vue').default,
  },
  data: function () {
    return {
      bIsPropertyOriented: false,
      propertyPreference: { propertyCode: '', accountCode: '', accountCount: 0, address: '', bShowDialog: false, profileAccount: '', bClicked: false },
      account: { name: '', account: '' },
      accounts: [],
      accountCodeSelected: '',
      accountNameSelected: '',
      dashboardKey: 0,
    }
  },
  watch: {
    languageLocale: function (value) {
      this.setLanguage(value);
      this.pageChange({ pageNumber: 1, pageSize: 10 });
    },
    accountCodeSelected: function (value) {
      this.accountNameSelected = this.accounts.filter(acc => acc.account == value)[0].name;
      this.getCustomerAccountDetails();
    },
  },
  computed: {
    languageLocale: function () {
      return this.$i18n.locale;
    }
  },
  created() {
    this.clearFilters();
    this.getSettings();
    this.getProfileDetails();
    this.getAccounts();
  },
  methods: {
    getProfileDetails() {
      axios.post('/account/GetProfileDetails')
        .then(response => {
          //add flag for field worker user
          //this.user['isFieldWorker'] = response.data.item.isFieldWorker;

          if (response.data.data.status == 0) {
            var resp = response.data.item;
            this.propertyPreference.profileAccount = resp.account;
            this.propertyPreference.accountCode = resp.selectedAccount && resp.selectedAccount.length > 0 ? resp.selectedAccount : resp.account;
            this.propertyPreference.bShowDialog = false;
            this.getPropertyLocalStorage();
          }
        })
        .catch(e => {
          this.$router.push('/login');
        })
    },
    getPropertyLocalStorage() {
      var propertyData = this.$localStorage.get('_property');
      if (propertyData && propertyData !== 'null')
        this.propertyPreference = JSON.parse(propertyData);
    },
    getSettings() {
      axios.post('/Utility/GetSettings')
        .then(response => {
          if (response.data.data.status == 0) {
            this.currencySymbol = response.data.value.currencySymbol;
            this.bIsPropertyOriented = response.data.value.isPropertyOriented;
          }
        });
    },
    getAccounts() {
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.get('/customer/GetAccounts')
        .then(response => {

          if ((this.propertyPreference) && (this.propertyPreference.accountCount > 1) && (this.propertyPreference.bShowDialog))
            this.accounts = response.data.items.filter(p => p.account == this.propertyPreference.accountCode);
          else
            this.accounts = response.data.items;

          if (this.accounts.length > 0) {
            this.accountCodeSelected = this.accounts[0].account;
            this.accountNameSelected = this.accounts[0].account;
            this.propertyPreference.bShowDialog = true;
          }
          loader.hide();
        })
        .catch(e => {
          loader.hide();
          this.$router.push('/login');
          return false;
        })
    },
    getCustomerAccountDetails() {
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/customer/GetAccountDetails', { Value: this.accountCodeSelected })
        .then(response => {
          this.account = response.data.item;
          this.propertyPreference.address = response.data.item.mailAddress;
          loader.hide();
        })
        .catch(e => {
          loader.hide();
          this.$router.push('/login');
          return false;
        })
    },
  }
}
